<template>
    <div class="page">
        <el-row :gutter="4" class="h100">
            <el-col :span="showList ? 4 : 1" :class="['p_r h100i', showList ? '' : 'el-col-unfold']" v-loading="showList && treeLoading">
                <div :class="['unfoldClassifyBtn', showList ? 'el-icon-arrow-left':'el-icon-arrow-right']"
                     @click="showList = !showList"></div>
                <el-tree class="h100 p_all1 metadataTree" :data="treeData" :props="defaultProps"
                         ref="myTree" node-key="id" highlight-current default-expand-all @node-click="selTreeNode">
                    <el-tooltip slot-scope="{ node, data }" effect="dark" :content="node.label" placement="top-start">
                        <div class="omit">
                            <img class="treeIcon" src="@/assets/img/dimensionalityIcon.png" v-if="data.basicType == 0"><img class="treeIcon" src="@/assets/img/atomIcon.png" v-else>
                            <span>{{ node.label }}</span>
                        </div>
                    </el-tooltip>
                </el-tree>
            </el-col>
            <el-col :span="showList ? 20 : 24" :class="['h100', showList ? '' : 'el-col-unfold']">
                <div class="el-table-container">
                    <el-form size="small" :inline="true" class="query-form" ref="searchForm" :model="searchForm"
                             @keyup.enter.native="refreshList(1)">
                        <el-form-item prop="basicName" label="元数据名称：">
                            <el-input v-model.trim="searchForm.basicName" maxlength="50" placeholder="请输入元数据名称"
                                      clearable></el-input>
                        </el-form-item>
                        <el-form-item prop="basicType" label="元数据类型：">
                            <el-select v-model="searchForm.basicType" placeholder="请选择元数据类型" clearable>
                                <el-option
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value"
                                        v-for="item in $dictUtils.getDictList('basic_type')">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item prop="basicAssemblyId" label="组件类型：">
                            <el-select v-model="searchForm.basicAssemblyId" filterable placeholder="请选择组件类型" clearable>
                                <el-option
                                        :key="item.id"
                                        :label="item.assemblyName"
                                        :value="item.id"
                                        v-for="item in basicAssemblyOpt">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="refreshList(1)" size="small"
                                       icon="el-icon-search">
                                查询
                            </el-button>
                            <el-button @click="reset()" size="small" icon="el-icon-refresh-right">重置</el-button>
                        </el-form-item>
                    </el-form>
                    <div class="text_right p_all1">
                        <el-button v-if="hasPermission('metadata:manageList:versions')" type="primary" size="small"
                                   icon="el-icon-thumb"
                                   @click="versionManagement()">版本管理
                        </el-button>
                        <el-button v-if="hasPermission('metadata:manageList:add')" type="primary" size="small"
                                   icon="el-icon-plus"
                                   @click="addEdit(null, 'add')">新增
                        </el-button>
                        <el-button v-if="hasPermission('metadata:manageList:import')" size="small"
                                   @click="importData()"><i class="icon-piliangdaoru iconfont buIcon"/>
                            批量导入
                        </el-button>
                        <el-button v-if="hasPermission('metadata:manageList:export')" size="small"
                                   @click="exportData()"><i class="icon-piliangdaochu iconfont buIcon"/>
                            批量导出
                        </el-button>
                        <el-button v-if="hasPermission('metadata:manageList:del')" type="danger" size="small"
                                   icon="el-icon-delete"
                                   @click="del()">批量删除
                        </el-button>
                    </div>
                    <el-table
                            :data="dataList"
                            v-loading="loading"
                            @selection-change="selectionChangeHandle"
                            size="small" height="100%"
                            class="table" ref="multipleTable" row-key='id' border>
                        <el-table-column fixed type="selection" :reserve-selection="true"></el-table-column>
                        <el-table-column type="index" label="序号" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="basicName" label="元数据名称" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="basicParentName" label="父级元数据名称" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="basicEnable" label="是否显示">
                            <template slot-scope="scope">
                                {{$dictUtils.getDictLabel("public_state", scope.row.basicEnable ,'')}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="basicType" label="类型" show-overflow-tooltip>
                            <template slot-scope="scope">
                                {{$dictUtils.getDictLabel("basic_type", scope.row.basicType ,'')}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="metadataBasicAssemblyName" label="组件类型"
                                         show-overflow-tooltip></el-table-column>
                        <el-table-column
                                fixed="right"
                                width="140"
                                label="操作">
                            <template slot-scope="scope">
                                <el-button v-if="hasPermission('metadata:manageList:view')" type="text" size="small"
                                           @click="addEdit(scope.row, 'view')">详情
                                </el-button>
                                <el-button v-if="hasPermission('metadata:manageList:edit')" type="text" size="small"
                                           @click="addEdit(scope.row, 'edit')">修改
                                </el-button>
                                <el-button v-if="hasPermission('metadata:manageList:del')" type="text" size="small"
                                           @click="del(scope.row.id)">删除
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <pagination :total="total" :page.sync="searchForm.current" :limit.sync="searchForm.size"
                                @pagination="refreshList"/>
                </div>
            </el-col>
        </el-row>
        <ManageForm ref="manageForm" @refreshDataList="refreshList()"></ManageForm>
        <VersionManagement ref="versionManagement"></VersionManagement>
        <ExportData ref="exportData"></ExportData>
        <ImportData ref="importData" @refreshDataList="refreshList(1)"></ImportData>
    </div>
</template>

<script>
    import ManageForm from './manageForm'
    import VersionManagement from './versionManagement'
    import ExportData from './exportData'
    import ImportData from './importData'

    export default {
        components: {ManageForm, VersionManagement, ExportData, ImportData},
        data() {
            return {
                showList: true,
                treeData: [],
                treeLoading: false,
                defaultProps: {
                    children: 'children',
                    label: 'basicName'
                },
                searchForm: {
                    basicAssemblyId: '',
                    basicId: '',
                    basicName: '',
                    basicType: '',
                    current: 1,
                    size: 20,
                },
                basicAssemblyOpt: [],
                dataList: [],
                total: 0,
                dataListSelections: [],
                loading: false,
            }
        },
        mounted() {
            this.getBasicAssembly()
            this.refreshList(1)
        },
        methods: {
            // 获取数据列表
            refreshList(type) {
                this.searchTree()
                if (type == 1) {
                    this.searchForm.current = 1
                }
                this.loading = true
                this.$axios(this.api.metadata.selectMetadataBasic, this.searchForm, 'post').then(data => {
                    if (data && data.status) {
                        this.dataList = data.data.records
                        if (this.dataList.length == 0 && this.searchForm.current > 1) {
                            this.searchForm.current--
                            this.refreshList()
                        }
                        this.dataList.map(item => {
                            delete item.children
                        })
                        this.total = parseInt(data.data.total)
                        this.loading = false
                    } else {
                        this.$message.error('查询失败');
                    }
                })
            },
            // 查询树状数据
            searchTree() {
                this.treeLoading = true
                this.$axios(this.api.metadata.selectTree).then(res => {
                    if (res.status) {
                        this.treeData = res.data
                        this.treeData.unshift({
                            basicName: '全部',
                            id: '',
                            children: []
                        })
                        this.$nextTick(() => {
                            if(this.treeData.length) {
                                this.$refs.myTree.setCurrentKey(this.treeData[0].id);
                            }
                        });
                    }
                    this.treeLoading = false
                })
            },
            // 获取组件类型
            getBasicAssembly() {
                this.$axios(this.api.metadata.selectAllMetadataBasicAssembly).then(res => {
                    if (res.status) {
                        this.basicAssemblyOpt = res.data.filter(v=> {return v.id != '19' && v.id != '20'})
                    }
                })
            },
            // 选择树节点
            selTreeNode(val) {
                this.searchForm.basicId = val.id
                this.refreshList(1)
            },
            // 新增
            addEdit(data, method) {
                this.$refs.manageForm.init(data, method)
            },
            // 版本管理
            versionManagement() {
                this.$refs.versionManagement.init()
            },
            // 删除
            del(id) {
                let ids = [id];
                if (!id && !this.dataListSelections.length) {
                    this.$message.warning('请至少选择一条数据')
                    return
                }
                if (!id) {
                    ids = this.dataListSelections.map(item => {
                        return item.id
                    })
                }
                const h = this.$createElement;
                this.$msgbox({
                    title: '温馨提示',
                    message: h('p', null, [
                        h('p', {style: 'color: #000000; margin-bottom: 5px'}, '确认删除所选元数据？'),
                        h('p', {style: 'color: #999999; font-size: 12px'}, '删除后元数据对应采集的数据也将会清空')
                    ]),
                    showCancelButton: true,
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                }).then(() => {
                    this.loading = true
                    this.$axios(this.api.metadata.removeById, ids, 'post').then(data => {
                        if (data.status) {
                            this.$refs.multipleTable.clearSelection()
                            this.$message.success('删除成功');
                        } else {
                            if(data.msg) {
                                const h = this.$createElement;
                                this.$msgbox({
                                    title: '温馨提示',
                                    message: h('p', null, [
                                        h('p', {style: 'color: #000000; margin-bottom: 5px'}, '不支持删除，所选元数据正在使用！'),
                                        h('p', {style: 'color: #999999; font-size: 12px'}, '请去【元数据模板管理】菜单中，删除对应的元数据。')
                                    ]),
                                    showCancelButton: true,
                                    confirmButtonText: '解除关联',
                                    cancelButtonText: '取消',
                                }).then(() => {
                                    this.$router.push({path: '/metadata/template/templateList'})
                                });
                            }
                        }
                        this.refreshList();
                        this.loading = false
                    })
                })
            },
            // 导入
            importData() {
                this.$refs.importData.init()
            },
            // 导出
            exportData() {
                let idList = this.dataListSelections.map(item => {
                    return item.id
                })
                this.$axios(this.api.user.configKey + '/export_item').then(data => {
                    if(data.status) {
                        if((!idList.length && this.total > parseInt(data.data)) || idList.length > parseInt(data.data)) {
                            this.$message('超出最大导出条数，当前：'+this.total+',限制' + data.data);
                        } else {
                            this.$refs.exportData.init(idList)
                        }
                    }
                })
            },
            // 多选
            selectionChangeHandle(val) {
                this.dataListSelections = val
            },
            // 重置
            reset() {
                this.dataListSelections = []
                this.$refs.searchForm.resetFields();
                this.$refs.multipleTable.clearSelection()
                this.refreshList(1)
            }
        }
    }
</script>
<style scoped lang="scss">

</style>
